import {
  Modal,
  ModalBody,
  ModalHeader,
  Button,
  Form,
  FormGroup,
  Label
} from "reactstrap";

import * as React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFolderOpen } from "@fortawesome/free-solid-svg-icons";
import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";

import i18n from "../i18n";
import { ScenarioModel } from "models/scenario";

interface OpenScenarioState {
  modalOpen: boolean;
  selectedScenario: ScenarioModel | null;
}

interface OpenScenarioProps {
  scenarios: any[];
  onSelected: (model: ScenarioModel | null) => void;
}

export default class OpenScenario extends React.Component<
  OpenScenarioProps,
  OpenScenarioState
> {
  constructor(props: any) {
    super(props);
    this.state = {
      selectedScenario: null,
      modalOpen: false
    };
  }

  render() {
    return (
      <Button color="primary" size="sm" onClick={() => this.toggleModal(true)} title="Open Scenario">
        <FontAwesomeIcon icon={faFolderOpen} />

        <Modal isOpen={this.state.modalOpen}>
          <ModalHeader>{i18n.Designer.Toolbox.OpenScenario}</ModalHeader>
          <ModalBody>
            <Form>
              <FormGroup>
                <Label>Scenario</Label>
                <Typeahead
                  labelKey={option => this.getLabelKey(option)}
                  bsSize="sm"
                  options={this.props.scenarios.filter(s => !s.isCustomScenario)}
                  selectHintOnEnter={true}
                  onChange={e => this.setSelected(e)}
                />
              </FormGroup>
            </Form>
            <Button
              color="primary"
              onClick={() => this.onSelect()}
              disabled={!this.state.selectedScenario}
            >
              {i18n.Designer.Toolbox.OpenButton}
            </Button>{" "}
            <Button onClick={() => this.toggleModal(false)}>
              {i18n.Global.Close}
            </Button>
          </ModalBody>
        </Modal>
      </Button>
    );
  }

  private toggleModal(set: boolean) {
    this.setState({
      modalOpen: set
    });
  }

  private getLabelKey(option: any) {
      if (option.languages) {
          return `${option.partitionKey}(Languages:${option.languages})`;
      } else {
          return `${option.partitionKey}`;
      }
  }

  private setSelected(e: any[]) {
    this.setState({
      selectedScenario: e[0]
    });
  }

  private onSelect() {
    this.setState({
      modalOpen: false
    });
    this.props.onSelected(this.state.selectedScenario);
  }
}



// WEBPACK FOOTER //
// ./src/designer/open-scenario.tsx